import BaseModel from '../../../../base/base_model';
import _ from '../../../../utils/underscore';
const balance = require('./view/balance.html'),
    userBadge = require('./view/user-badge.html'),
    cashier = require('./view/cashier.html');


/**
 *
 *
 *
 */
class LoggedinInlineLayoutModel extends BaseModel {


    /**
     * @property
     * @type {string[]}
     * @private
     */
    _bindingSelectorDOM = [
        '.balance',
        '.username'
    ];


    /**
     *
     * @param params
     */
    init(params) {
        if (params) {
            this
                ._setLayoutType(params.layoutType)
                ._setSilentMode(params.silentMode)
                ._setShowCashier(params.showCashier)
                ._setShowMenu(params.showMenu)
                ._setShowUsername(params.showUsername)
                ._setCashierOpenType(params.cashierOpenType)
                ._setShowBalance(params.showBalance)
                ._setShowGreeting(params.showGreeting)
                ._setShowUserBadge(params.showUserBadge)
                ._setPostCTAClickedFn(params.postCTAClickedFn);
        }
    }


    /**
     *
     * @param layoutType
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setLayoutType(layoutType) {
        this._layoutType = layoutType;
        return this;
    }


    /**
     *
     * @param silentMode
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setSilentMode(silentMode) {
        this._silentMode = silentMode;
        return this;
    }


    /**
     *
     * @param showCashier
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setShowCashier(showCashier) {
        this._showCashier = showCashier;
        return this;
    }


    /**
     *
     * @param cashierOpenType
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setCashierOpenType(cashierOpenType) {
        this._cashierOpenType = cashierOpenType;
        return this;
    }


    /**
     *
     * @param showMenu
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setShowMenu(showMenu) {
        this._showMenu = showMenu;
        return this;
    }


    /**
     *
     * @param showUsername
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setShowUsername(showUsername) {
        this._showUsername = showUsername;
        return this;
    }


    /**
     *
     * @param showBalance
     * @returns {*}
     * @private
     */
    _setShowBalance(showBalance) {
        this._showBalance = showBalance;
        return this;
    }


    /**
     *
     * @param showGreeting
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setShowGreeting(showGreeting) {
        this._showGreeting = showGreeting;
        return this;
    }


    /**
     * Define whether show user badge
     * @param showUserBadge
     * @private
     */
    _setShowUserBadge(showUserBadge) {
        this._showUserBadge = showUserBadge;
        return this;
    }

    /**
     * Set handle function that will be called on balance click
     * @param fnName
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setPostCTAClickedFn(fnName) {
        if (!_.isString(fnName)) {
            return this;
        }

        this._postCTAClickedFn = fnName;
        return this;
    }


    /**
     * Set New free plays status
     * @param isNewFreePlay
     */
    setIsFreePlay(isFreePlay) {
        this._isNewFreePlay = isFreePlay;
        return this;
    }


    /**
     * Set OMG messages status
     * @param isOMGExist
     * @returns {LoggedinInlineLayoutModel}
     */
    setIsOMGMessageExist(isOMGExist) {
        this._isOMGExist = isOMGExist;
        return this;
    }


    /**
     * Get layout type.
     *
     * @returns {*}
     */
    getLayoutType() {
        return this._layoutType;
    }


    /**
     *
     * @returns {*}
     */
    getShowCashier() {
        return this._showCashier;
    }


    /**
     *
     * @returns {*}
     */
    getShowBalance() {
        return this._showBalance;
    }


    /**
     *
     */
    getShowMenu() {
        return this._showMenu;
    }


    /**
     *
     * @returns {*|boolean}
     */
    getShowUsername() {
        return this._showUsername;
    }


    /**
     *
     * @returns {string}
     * @public
     */
    getshowCashier() {
        return this._showCashier ? cashier : '';
    }


    /**
     *
     * @returns {string}
     */
    getshowMenu() {
        return this._showMenu ? window.mockMenu : '';
    }


    /**
     *
     * @returns {string}
     */
    getshowBalance() {
        return this._showBalance ? balance : '';
    }


    /**
     *
     * @returns {string}
     */
    getshowUsername() {
        return this._showUsername ? balance : '';
    }


    /**
     *
     * @returns {*}
     */
    getshowGreeting() {
        return this._showGreeting;
    }


    /**
     *
     * @returns {string[]}
     */
    getBindingSelectorDOM() {
        return this._bindingSelectorDOM;
    }


    /**
     *
     * @returns {*}
     */
    getCashierOpenType() {
        return this._cashierOpenType;
    }


    /**
     * Get New free plays status
     * @returns {*}
     */
    getIsFreePlay() {
        return this._isNewFreePlay;
    }


    /**
     * Get OMG messages status
     * @returns {*}
     */
    getIsOMGExist() {
        return this._isOMGExist;
    }


    /**
     * Get external handle function for balance click
     * @returns {*}
     */
    getPostCTAClickedFn() {
        return this._postCTAClickedFn;
    }

    getshowUserBadge() {
        return this._showUserBadge ? userBadge : '';
    }
}

export default LoggedinInlineLayoutModel;